/**
 * Hand-built Part inspector editors per shape type (PartInspector falls back
 * to generic fields for types without one). Aliases map like prism's serde
 * aliases (`plant` → tree, `fabric` → cloth, ...).
 */

import { createElement, type ComponentType } from 'react';

import { BlobEditor } from './BlobEditor.js';
import { ClothEditor } from './ClothEditor.js';
import type { ShapeEditorProps } from './doc-context.js';
import { GarmentEditor } from './GarmentEditor.js';
import { HairEditor } from './HairEditor.js';
import { ExtrudeEditor, LatheEditor } from './LatheEditor.js';
import { LoftEditor } from './LoftEditor.js';
import { SkinEditor } from './SkinEditor.js';
import { SweepEditor } from './SweepEditor.js';
import { TreeEditor } from './TreeEditor.js';
import { TubeEditor } from './TubeEditor.js';

export type { ShapeEditorProps } from './doc-context.js';

export const SHAPE_EDITORS: Record<string, ComponentType<ShapeEditorProps>> = {
  lathe: LatheEditor,
  extrude: ExtrudeEditor,
  tube: TubeEditor,
  sweep: SweepEditor,
  loft: LoftEditor,
  blob: BlobEditor,
  tree: TreeEditor,
  plant: TreeEditor,
  skin: SkinEditor,
  skeleton: SkinEditor,
  hair: HairEditor,
  hairCards: HairEditor,
  cloth: ClothEditor,
  fabric: ClothEditor,
  garment: GarmentEditor,
  clothing: GarmentEditor,
  armor: GarmentEditor,
};

/** The registered editor for `shape.type` (nothing when there is none). */
export function ShapeEditor(props: ShapeEditorProps) {
  const Editor = SHAPE_EDITORS[props.shape.type];
  return Editor ? createElement(Editor, props) : null;
}
